export default "__VITE_ASSET__287ee08d__"